export default {"src":"/_next/static/media/integration-ux-ui-scenarios.d03241f8.svg","height":150,"width":329,"blurWidth":0,"blurHeight":0};